import React, { useState, useEffect } from 'react';
import './KeyStatistics.scss';

const KeyStatistics = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('key-statistics-section');
      if (element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Check if section is 50% visible
        if (rect.top < windowHeight * 0.5 && rect.bottom > windowHeight * 0.5) {
          setIsVisible(true);
        } else if (rect.bottom < -100 || rect.top > windowHeight + 100) {
          // Reset when section is completely out of view
          setIsVisible(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="key-statistics-section" className={`key-statistics-section ${isVisible ? 'animate' : ''}`}>
      <div className="container">
        <div className="statistics-content">
          {/* Left Side - Title and Description */}
          <div className="statistics-left">
            <h2 className="section-title">Key Statistics</h2>
            <p className="section-subtitle">
              A snapshot of energy access and renewable energy financing impact across Africa.
            </p>
          </div>

          {/* Right Side - Statistics Grid */}
          <div className="statistics-right">
            <div className="statistics-grid">
              {/* Top Left - Total Projects (Orange, horizontal layout) */}
              <div className="stat-card stat-card-1">
                <div className="stat-content-horizontal">
                  <div className="stat-left-content">
                    <div className="stat-number">856</div>
                    <div className="stat-label">Total Projects</div>
                  </div>
                  <div className="stat-icon">
                    <img src="/images/key-statistics/total-project-icon.png" alt="Total Projects" />
                  </div>
                </div>
                <div className="stat-details">
                  <div className="stat-subtitle">Across 35 countries</div>
                  <div className="stat-growth">
                    <span className="growth-arrow orange">↗</span>
                    <span className="growth-text">15% from previous year</span>
                  </div>
                </div>
              </div>

              {/* Top Right - Renewable Energy Projects (Black, centered) */}
              <div className="stat-card stat-card-2">
                <div className="stat-content-centered">
                  <div className="stat-number">412</div>
                  <div className="stat-label">Renewable Energy Projects</div>
                </div>
                <div className="stat-details">
                  <div className="stat-subtitle">Solar, Wind & Hydro</div>
                  <div className="stat-growth">
                    <span className="growth-arrow green">↗</span>
                    <span className="growth-text">22% from previous year</span>
                  </div>
                </div>
              </div>

              {/* Bottom Left - Energy Access Projects (Light gray, centered) */}
              <div className="stat-card stat-card-3">
                <div className="stat-content-centered">
                  <div className="stat-number">170</div>
                  <div className="stat-label">Energy Access Projects</div>
                </div>
                <div className="stat-details">
                  <div className="stat-subtitle">Off-grid Solutions</div>
                  <div className="stat-growth">
                    <span className="growth-arrow green">↗</span>
                    <span className="growth-text">12% from previous year</span>
                  </div>
                </div>
              </div>

              {/* Bottom Right - Population Served (Orange, centered) */}
              <div className="stat-card stat-card-4">
                <div className="stat-content-horizontal">
                  <div className="stat-left-content">
                    <div className="stat-number">45M+</div>
                    <div className="stat-label">Population Served</div>
                  </div>
                  <div className="stat-icon">
                    <img src="/images/key-statistics/population-icon.png" alt="Population Served" />
                  </div>
                </div>
                <div className="stat-details">
                  <div className="stat-subtitle">Direct beneficiaries</div>
                  <div className="stat-growth">
                    <span className="growth-arrow orange">↗</span>
                    <span className="growth-text">18% from previous year</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyStatistics;



